import { User } from '../context/AuthContext'
import apiClient from './apiClient'

// Backend returns permission_ids (snake_case); map to the camelCase User shape.
interface UserResponse {
  email: string
  firstName: string
  lastName: string
  permission_ids?: number[]
  roles?: string[]
}

export const getOwnUser = async (): Promise<User> => {
  try {
    const response = await apiClient.get<UserResponse>('/users/me')
    const data = response.data
    return {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      permissionIds: data.permission_ids || [],
      roles: data.roles || [],
    }
  } catch (error) {
    console.error('Error getting user details:', error)
    throw error
  }
}

// The signed-in user's Entra profile photo, as an object URL for an <img>, or
// null when they have none (a 404) or it cannot be read. Fetched rather than
// linked because every API call carries the X-API-Key header, which an <img>
// request cannot.
export const getOwnPhoto = async (): Promise<string | null> => {
  try {
    const response = await apiClient.get<Blob>('/users/me/photo', {
      responseType: 'blob',
    })
    return URL.createObjectURL(response.data)
  } catch {
    return null
  }
}
